import { TravelerItemUI, PASSENGER_TO_TRAVELER, PAX_TO_TRAVELER } from '@pax/entities/pax-ui';
import { TravelerInfoType, TravelerTypes } from '@pax/entities/traveler-info';
import { ordinal } from '@pax/mappers/ordinal.mapper';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { Fares, PriceType } from '@activities/activities-results/entities/activities-results';

export function passengerListUI(passengerArrangement: PassengerArrangement[], type: SearchBy): TravelerItemUI[] {
  const travelers = passengerArrangement
    .map((arrangement: PassengerArrangement) =>
      [].constructor(arrangement.quantity)
        .fill({
          TravelerInfoType: getTravelerInfoType(type),
          TravelerType: PASSENGER_TO_TRAVELER[arrangement.id],
        }).map((traveler, index) => ({
          ...traveler,
          OrdinalKey: ordinal(index + 1),
          OrdinalNumber: index + 1,
          IndexTypeNumber: index,
        })));
  return [].concat(...travelers).map((traveler, index) => ({ ...traveler, id: index }));
}

export function farePassengerListUI(fares: Fares[], requireAllPaxInfo: boolean): TravelerItemUI[] {
  const priceType = fares?.[0]?.PriceType;
  const isPricePerService = priceType === PriceType.PerService;
  const _fares = isPricePerService ? fares.filter((_fareA, i, _arr) =>
    _arr.findIndex(_fareB => (_fareB.PriceType === _fareA.PriceType)) === i
  ) : fares;
  const useQuantity = !isPricePerService && requireAllPaxInfo;
  const mappedFares = (useQuantity ? _fares : [_fares?.[0]]) ?? [];
  const travelers = mappedFares
    .map((fare: Fares) =>
      [].constructor(useQuantity ? fare.Quantity : 1)
        .fill({
          TravelerInfoType: TravelerInfoType.PASSENGER,
          TravelerType: useQuantity ? PAX_TO_TRAVELER[fare.PaxType] : TravelerTypes.ADULTS,
          FareId: fare.FareId,
        }).map((traveler, i) => ({
          ...traveler,
          OrdinalKey: ordinal(i + 1),
          OrdinalNumber: i + 1,
          IndexTypeNumber: i,
        })));
  return [].concat(...travelers).map((traveler, index) => ({
    ...traveler,
    id: index,
    LinealOrdinalKey: ordinal(index + 1),
  }));
}

export function passengerIdentificatorUI(id: number): string {
  return `${TravelerInfoType.PASSENGER}_${id}`;
}

export function isPassengerUIByPaxEffect(type: TravelerInfoType): boolean {
  switch (type) {
    case TravelerInfoType.PASSENGER:
    case TravelerInfoType.DRIVER:
    case TravelerInfoType.PERSON:
      return true;
    default:
      return false;
  }
}

function getTravelerInfoType(type: SearchBy): TravelerInfoType {
  switch (type) {
    case SearchBy.PACKAGES:
      return TravelerInfoType.PACKAGE_TRAVELER;
    default:
      return TravelerInfoType.PASSENGER;
  }
}
